import { motion } from "framer-motion";
import { FaFacebook, FaTwitter, FaLinkedin, FaYoutube, FaMapMarkerAlt } from "react-icons/fa";

export default function Footer() {
  return (
     <footer className="relative bg-gradient-to-b from-[#016C94] to-[#016C94] text-white overflow-hidden">
      {/* SVG Decorative Top Wave */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0]">
        <svg
          className="relative block w-full h-12"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          viewBox="0 0 1200 120"
        >
          <path
            d="M321.39,56.44c58-10.79,114-30.13,172-41.84,
            82.78-16.64,168.8-19.6,252.82-8.46C861.06,19.81,
            936.9,49,1018.68,63.26c69.51,11.84,
            140.46,13.65,209.53,2.27V0H0V27.35
            A600.21,600.21,0,0,0,321.39,56.44Z"
            className="fill-white opacity-20"
          ></path>
        </svg>
      </div>

      {/* Container */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12 space-y-12">
        {/* Row 1 */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <img
            src="/img/uctc-head-logo.png"
            alt="UCTC Logo"
            className="w-52 bg-white rounded-lg p-2 shadow-lg"
          />

          {/* Social Icons */}
          <div className="flex space-x-6 text-2xl">
            <motion.a
              whileHover={{ scale: 1.2 }}
              href="https://www.facebook.com/UCTCBD/"
              className="hover:text-gray-200"
            >
              <FaFacebook />
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.2 }}
              href="#"
              className="hover:text-gray-200"
            >
              <FaTwitter />
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.2 }}
              href="https://www.linkedin.com/school/uctcbd/"
              className="hover:text-gray-200"
            >
              <FaLinkedin />
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.2 }}
              href="https://www.youtube.com/@uctcbd"
              className="hover:text-gray-200"
            >
              <FaYoutube />
            </motion.a>
          </div>

			{/* Apply Button */}
			<div className="mt-4 md:mt-0">
				
			  <a
				href="/apply-online"
				className="px-6 py-2 bg-white text-[#1f6da8] font-semibold rounded-full shadow hover:bg-[#f5f5f5] hover:scale-105 transition animate-pulse"
			  >
				Apply Online
			  </a>
			</div>
        </div>
		
        {/* Row 2 */}
        <div className="grid md:grid-cols-4 gap-8 text-gray-200">
          <div>
            <h4 className="text-lg font-semibold mb-3 text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/about" className="hover:text-white">About Us</a></li>
              <li><a href="/admission-requirement" className="hover:text-white">Admissions</a></li>
              <li><a href="/why-us" className="hover:text-white">Why Us</a></li>
			  <li><a href="/fees" className="hover:text-white">Tuition Fees</a></li>
              <li><a href="/research" className="hover:text-white">Research</a></li>
			  <li><a href="/faculty" className="hover:text-white">Our Faculty</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-3 text-white">Academics</h4>
            <ul className="space-y-2">
              <li><a href="/academic-system" className="hover:text-white">Academic System</a></li>
              <li><a href="/academic-policy" className="hover:text-white">Academic Policy</a></li>
              <li><a href="/academic-calendar" className="hover:text-white">Academic Calendar</a></li>
              <li><a href="/scholarship" className="hover:text-white">Scholarships & Financial Assistance</a></li>
			  <li><a href="/certificate-verification" className="hover:text-white">Certificate Verification</a></li>
			  <li><a href="/contact" className="hover:text-white">Contact Us</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-3 text-white">Resources</h4>
            <ul className="space-y-2">
              <li><a href="https://opac.uctc.edu.bd" className="hover:text-white">Library</a></li>
              <li><a href="https://web.uctc.edu.bd/login" className="hover:text-white">Student Portal</a></li>
              <li><a href="/alumni" className="hover:text-white">Alumni</a></li>
              <li><a href="/all-events" className="hover:text-white">Events</a></li>
			  <li><a href="/gallery" className="hover:text-white">Gallery</a></li>
			  <li><a href="/videos" className="hover:text-white">Videos</a></li>
			  
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-3 text-white">Contact</h4>
            <p>University of Creative Technology, Chittagong</p>
			<p>📍 Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212</p>
            <p>📞 +88-031-2555721-24, +88-01707-507070-71, +88-01707-508080-81</p>
            <p>✉️ info@uctc.edu.bd</p>
          </div>
        </div>

        {/* Row 3 */}
        <div className="flex flex-col md:flex-row items-center justify-between text-sm text-gray-200 border-t border-yellow-400 pt-6">
          <p>© {new Date().getFullYear()} UCTC. All Rights Reserved.</p>
          <div className="flex space-x-4">
            <a href="#" className="hover:text-white">Legal</a>
            <a href="#" className="hover:text-white">Privacy Policy</a>
          </div>
        </div>
		
      </div>
		{/* Bottom SVG Wave */}
		<div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0] rotate-180">
			<svg
			  className="relative block w-full h-12"
			  xmlns="http://www.w3.org/2000/svg"
			  preserveAspectRatio="none"
			  viewBox="0 0 1200 120"
			>
			  <path
				d="M321.39,56.44c58-10.79,114-30.13,172-41.84,
				82.78-16.64,168.8-19.6,252.82-8.46C861.06,19.81,
				936.9,49,1018.68,63.26c69.51,11.84,
				140.46,13.65,209.53,2.27V0H0V27.35
				A600.21,600.21,0,0,0,321.39,56.44Z"
				className="fill-white opacity-20"
			  ></path>
			</svg>
		</div>
    </footer>
  );
}
